import { StringServiceResponse } from 'model';
import { BaseApi } from './BaseAPI';

export const VersionApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getReleaseVersion: builder.query<StringServiceResponse, {}>({
			query: () => ({
				url: `releaseVersion/`
			})
		})
	})
});

export const { useGetReleaseVersionQuery } = VersionApi;
